import { useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { cancelSubscription } from "../../utils/auth/updateUser";
import { useAuthContext } from "../../utils/auth/useAuth";
import { useCancelSubscriptionDialog } from "../../utils/useCancelSubscriptionDialog";
import { useChangePlanDialog } from "../../utils/useChangePlanDialog";
import { usePaymentDialog } from "../../utils/usePaymentDialog";

type CardCommonProps = {
  loading?: boolean;
  current: boolean;
  name: string;
  perks: React.ReactNode;
};

type CardProps =
  | ({
      free: true;
      planId: "free";
    } & CardCommonProps)
  | ({
      free?: undefined;
      price: string;
      userEmail?: string;
      planId: string;
      hasPlan: boolean;
    } & CardCommonProps);

export function PlanCard(props: CardProps) {
  const theme = useTheme();

  const { user, setShowLogin } = useAuthContext();

  const { openPaymentDialog } = usePaymentDialog();
  const { Dialog, openChangePlanDialog } = useChangePlanDialog();
  const { dialog: cancelDialog, openCancelSubscriptionDialog } = useCancelSubscriptionDialog();

  const { current, loading } = props;

  const onSubscribeRequest = (planId: string) => {
    if (!user) {
      setShowLogin(true);
      return;
    }

    openPaymentDialog(planId);
    return;
  };

  // const handleSubscriptionCancel = () => {
  //   cancelSubscription().then((result) => {
  //     // Read result of the Cloud Function.
  //     var sanitizedMessage = result.data.text;
  //   });
  // };

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: { xs: 2, sm: 3, md: 4 },
        height: "100%",
        position: "relative",
        ...(current && {
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: theme.palette.primary.main,
          boxShadow: `0px 3px 3px -2px ${theme.palette.primary.main}33, 0px 3px 4px 0px ${theme.palette.primary.main}24, 0px 1px 8px 0px ${theme.palette.primary.main}1f`,
        }),
      }}
      variant="outlined"
    >
      {Dialog}
      {cancelDialog}

      {current && (
        <Chip
          sx={{ minHeight: 24, marginBottom: 2, position: "absolute", top: -12 }}
          label="Este é seu plano atual"
          color="primary"
          size="small"
        />
      )}

      <Typography variant="h3">{props.name}</Typography>

      <Box marginY={3}>{props.perks}</Box>

      {!props.free && (
        <>
          <Typography
            sx={{
              marginTop: "auto",
              marginBottom: 4,
            }}
            variant="h3"
          >
            {props.price}
          </Typography>
          <Box minHeight={80} width="100%" textAlign="center">
            {loading ? (
              <CircularProgress sx={{ color: "grey.500" }} />
            ) : current ? (
              <Button onClick={openCancelSubscriptionDialog} fullWidth color="primary" variant="outlined">
                Cancelar assinatura
              </Button>
            ) : (
              <>
                {props.planId &&
                  (props.hasPlan ? (
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        onSubscribeRequest(props.planId);
                      }}
                    >
                      Mudar para este
                    </Button>
                  ) : (
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        onSubscribeRequest(props.planId);
                      }}
                    >
                      Assinar este plano
                    </Button>
                  ))}
              </>
            )}
          </Box>
        </>
      )}
    </Paper>
  );
}
